import React, { createContext, useState, useContext, useEffect } from "react";

// Create the context
const GlobalContext = createContext();

// Create a provider component
export const GlobalProvider = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [formSource, setFormSource] = useState("NAA");

  // Function to update the state
  // const updateModalState = (newValue) => {
  //   setShowModal(newValue);
  // };
  //
  useEffect(() => {
    setTimeout(() => {
      if (!showModal) {
        handleShowModal("Timer Popup");
      }
    }, 7000);
  }, []);
  const handleShowModal = (source) => {
    setFormSource(source);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setFormSource("NAA");
  };

  return (
    <GlobalContext.Provider
      value={{ showModal, handleShowModal, handleCloseModal, formSource }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

// Custom hook for using the Global Context
export const useGlobalContext = () => {
  return useContext(GlobalContext);
};
